import { render, staticRenderFns } from "./WorkersWidgetComponent.vue?vue&type=template&id=d39b8134&scoped=true&"
import script from "./WorkersWidgetComponent.vue?vue&type=script&lang=ts&"
export * from "./WorkersWidgetComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WorkersWidgetComponent.vue?vue&type=style&index=0&id=d39b8134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39b8134",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
